'use client'

import {
  TooltipArrow,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
  Tooltip as BaseTooltip,
} from '@dc-shared-web/components/shadcn/tooltip'
import { useState } from 'react'

type TooltipProps = {
  children: React.ReactNode
  content: React.ReactNode
  side?: 'top' | 'bottom' | 'left' | 'right'
  sideOffset?: number
  align?: 'start' | 'center' | 'end'
  alignOffset?: number
  withArrow?: boolean
  className?: string
  active?: boolean
  allowClickToOpen?: boolean
}

export const Tooltip = ({
  children,
  content,
  side = 'bottom',
  sideOffset = 0,
  align = 'center',
  alignOffset = 0,
  withArrow = false,
  className,
  active = true,
  allowClickToOpen = false,
}: TooltipProps) => {
  const [open, setOpen] = useState(false)

  const handleClick = () => {
    if (!allowClickToOpen) return
    setOpen(!open)
  }

  return (
    <TooltipProvider>
      <BaseTooltip open={open} onOpenChange={setOpen} delayDuration={150}>
        <TooltipTrigger
          asChild
          onMouseEnter={() => setOpen(true)}
          onMouseLeave={() => setOpen(false)}
          onClick={handleClick}
        >
          {children}
        </TooltipTrigger>
        {active && (
          <TooltipContent
            side={side}
            sideOffset={sideOffset}
            align={align}
            alignOffset={alignOffset}
            className={className}
            data-testid='tooltip'
          >
            {withArrow && <TooltipArrow />}
            {content}
          </TooltipContent>
        )}
      </BaseTooltip>
    </TooltipProvider>
  )
}
